export default __webpack_public_path__ + "static/media/eight.9b29c30b.jpg";